import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5e1dc4d2")

_pushScopeId("data-v-5e1dc4d2")
const _hoisted_1 = {
  key: 0,
  class: "card-header border-0 pt-5"
}
const _hoisted_2 = { class: "card-title align-items-center" }
const _hoisted_3 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Publish History", -1)
const _hoisted_5 = { class: "table-responsive mb-6" }
const _hoisted_6 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bold text-muted" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "ID"),
    /*#__PURE__*/_createVNode("th", null, "Status"),
    /*#__PURE__*/_createVNode("th", null, "Scope"),
    /*#__PURE__*/_createVNode("th", null, "Platforms"),
    /*#__PURE__*/_createVNode("th", null, "Posted"),
    /*#__PURE__*/_createVNode("th", null, "Skipped"),
    /*#__PURE__*/_createVNode("th", null, "Failed"),
    /*#__PURE__*/_createVNode("th", null, "Failed"),
    /*#__PURE__*/_createVNode("th", null, "Created"),
    /*#__PURE__*/_createVNode("th", { class: "pe-4 text-end" }, "Actions")
  ])
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createVNode("td", {
  colspan: "9",
  class: "ps-4 pe-4 text-muted"
}, "No campaigns yet.", -1)
const _hoisted_10 = { class: "ps-4" }
const _hoisted_11 = { class: "badge badge-light-primary text-uppercase" }
const _hoisted_12 = { class: "pe-4 text-end" }
const _hoisted_13 = {
  key: 0,
  class: "border rounded p-4"
}
const _hoisted_14 = { class: "d-flex flex-wrap justify-content-between align-items-center mb-4 gap-2" }
const _hoisted_15 = { class: "mb-0" }
const _hoisted_16 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_17 = { class: "table-responsive" }
const _hoisted_18 = { class: "table align-middle gs-0 gy-3" }
const _hoisted_19 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bold text-muted" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "USID"),
    /*#__PURE__*/_createVNode("th", null, "Platform"),
    /*#__PURE__*/_createVNode("th", null, "Account"),
    /*#__PURE__*/_createVNode("th", null, "Status"),
    /*#__PURE__*/_createVNode("th", { class: "pe-4" }, "Error")
  ])
], -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createVNode("td", {
  colspan: "5",
  class: "ps-4 pe-4 text-muted"
}, "No post entries.", -1)
const _hoisted_22 = { class: "ps-4" }
const _hoisted_23 = { class: "text-capitalize" }
const _hoisted_24 = { class: "pe-4 text-muted" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", null, [
      _createVNode("div", {
        class: _ctx.embedded ? '' : 'card seq-card mb-5'
      }, [
        (!_ctx.embedded)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("h3", _hoisted_2, [
                _createVNode("span", _hoisted_3, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Clipboard.svg" })
                ]),
                _hoisted_4
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: _ctx.embedded ? '' : 'card-body py-3'
        }, [
          _createVNode("div", _hoisted_5, [
            _createVNode("table", _hoisted_6, [
              _hoisted_7,
              _createVNode("tbody", null, [
                (_ctx.campaigns.length === 0)
                  ? (_openBlock(), _createBlock("tr", _hoisted_8, [
                      _hoisted_9
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.campaigns, (campaign) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: campaign.id,
                    class: { 'table-active': _ctx.selectedCampaignId === campaign.id },
                    style: {"cursor":"pointer"},
                    onClick: ($event: any) => (_ctx.selectCampaign(campaign.id))
                  }, [
                    _createVNode("td", _hoisted_10, "#" + _toDisplayString(campaign.id), 1),
                    _createVNode("td", null, [
                      _createVNode("span", _hoisted_11, _toDisplayString(campaign.status), 1)
                    ]),
                    _createVNode("td", null, _toDisplayString(_ctx.formatScope(campaign.teamId)), 1),
                    _createVNode("td", null, _toDisplayString((campaign.platforms || []).join(', ')), 1),
                    _createVNode("td", null, _toDisplayString(campaign.stats?.posted || 0), 1),
                    _createVNode("td", null, _toDisplayString(campaign.stats?.skipped || 0), 1),
                    _createVNode("td", null, _toDisplayString(campaign.stats?.failed || 0), 1),
                    _createVNode("td", null, _toDisplayString(_ctx.formatDate(campaign.createdAt)), 1),
                    _createVNode("td", _hoisted_12, [
                      (_ctx.isEditable(campaign))
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-sm btn-light-primary me-2",
                            onClick: _withModifiers(($event: any) => (_ctx.editCampaign(campaign.id)), ["stop"])
                          }, " Edit ", 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.isEditable(campaign))
                        ? (_openBlock(), _createBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-sm btn-light-danger",
                            disabled: _ctx.discardingId === campaign.id,
                            onClick: _withModifiers(($event: any) => (_ctx.discardCampaign(campaign.id)), ["stop"])
                          }, _toDisplayString(_ctx.discardingId === campaign.id ? "Discarding..." : "Discard"), 9, ["disabled", "onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, ["onClick"]))
                }), 128))
              ])
            ])
          ]),
          (_ctx.selectedCampaignId)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("h5", _hoisted_15, "Post log for campaign #" + _toDisplayString(_ctx.selectedCampaignId), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-light-primary",
                    disabled: _ctx.retrying,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.retrySelected && _ctx.retrySelected(...args)))
                  }, _toDisplayString(_ctx.retrying ? 'Retrying...' : 'Retry Failed'), 9, ["disabled"])
                ]),
                (_ctx.selectedCampaign?.status === 'rejected')
                  ? (_openBlock(), _createBlock("div", _hoisted_16, " Blocked by AI review: " + _toDisplayString(_ctx.selectedCampaign.moderationResult?.summary || 'Post violates company rules.'), 1))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_17, [
                  _createVNode("table", _hoisted_18, [
                    _hoisted_19,
                    _createVNode("tbody", null, [
                      (_ctx.fanoutItems.length === 0)
                        ? (_openBlock(), _createBlock("tr", _hoisted_20, [
                            _hoisted_21
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fanoutItems, (item) => {
                        return (_openBlock(), _createBlock("tr", {
                          key: item.id
                        }, [
                          _createVNode("td", _hoisted_22, _toDisplayString(item.targetUsid), 1),
                          _createVNode("td", _hoisted_23, _toDisplayString(item.platform || '-'), 1),
                          _createVNode("td", null, _toDisplayString(item.accountId || '-'), 1),
                          _createVNode("td", null, _toDisplayString(item.status), 1),
                          _createVNode("td", _hoisted_24, _toDisplayString(item.error || '-'), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ]))
})